import React from 'react';
import classnames from 'classnames';

const SaveButton = ({
	show,
	close,
}) => (
	<button
		className={classnames("btn save-btn", {hidden: !show})}
		onClick={close}>
		<i className="glyphicon glyphicon-ok" />
	</button>
);

export default SaveButton;


// WEBPACK FOOTER //
// ./src/diets/SaveButton.js